export default __webpack_public_path__ + "static/ylibka_radugi-c933db55dcad78ef06e4bed1e534595c.png";